/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import '../../../../style/layout/layout.scss';

import { node, number } from 'prop-types';
import React from 'react';
import classnames from 'classnames';

const PreferencesCol = ({ children, className, col, mobile }) => {
  const classes = classnames(`col-${col}`, className, {
    [`mobile-${mobile}`]: mobile
  });

  return <div className={classes}>{children}</div>;
};

PreferencesCol.propTypes = {
  children: node,
  col: number.isRequired
};

export default PreferencesCol;
